import BOHComments from './BOHComments';
export default BOHComments;